import React, {useMemo} from "react"
import {Dialog, DialogContent, IconButton, styled} from "@mui/material"
import {getMerkmal} from "../../misc/widget-functions"
import Content from "../../components/Content"
import {Close} from "@mui/icons-material"

export const containerDialogPrototype = [
    {
        key: "fullwidth",
        type: "YESNO",
        label: "Fullwidth",
        size: 3,
    },
    {
        key: "ignoreOutsideClick",
        type: "YESNO",
        label: "Outside klick verhindern",
        size: 3,
    },
    {
        key: "closeAction",
        type: "STRING",
        label: "On close Action",
        size: 3,
    },
    {
        key: "showDefaultCloseButton",
        type: "YESNO",
        label: "Default schliessen Button anzeigen",
        size: 3,
    },
    {
        key: "maxWidth",
        type: "SELECT",
        label: "Breakpoint",
        size: 3,
        options: [
            {
                value: "xs",
                label: "xs",
            },
            {
                value: "sm",
                label: "sm",
            },
            {
                value: "md",
                label: "md",
            },
            {
                value: "lg",
                label: "lg",
            },
            {
                value: "xl",
                label: "xl",
            },
            {
                value: "false",
                label: "false",
            },
        ],
    },
]

const StyledDialogContent = styled(DialogContent)(({theme}) => ({
    paddingTop: theme.spacing(3),
    position: "relative",
}))

const CloseButton = styled(IconButton)(({}) => ({
    position: "absolute",
    backgroundColor: "transparent",
    right: 8,
    top: 8,
    zIndex: 1,
}))

const ContainerDialog = ({
    container,
    onValueChange,
    triggerAction,
    value: open,
}) => {
    const {children, ignoreOutsideClick = false} = container
    const maxWidth = container?.maxWidth ?? "sm"
    const minWidth = container?.minWidth ?? "sm"
    const fullwidth = container?.fullwidth ?? false
    const closeModal = () => {
        onValueChange(false)
        if (container.closeAction) {
            triggerAction(container.closeAction)
        }
    }

    return (
        <Dialog
            fullWidth={fullwidth}
            open={open}
            onClose={ignoreOutsideClick ? undefined : closeModal}>
            {container?.showDefaultCloseButton && (
                <CloseButton
                    aria-label="close"
                    onClick={closeModal}
                    size="large">
                    <Close />
                </CloseButton>
            )}

            <StyledDialogContent sx={{maxWidth: maxWidth, minWidth: minWidth}}>
                {children.map((child) => (
                    <Content
                        key={child.id}
                        child={child}
                    />
                ))}
            </StyledDialogContent>
        </Dialog>
    )
}

export default ContainerDialog
